import * as React from "react";
import { CallbackParams, FormModel } from "./types";
import settings from "../settings.json";
import Button from "antd/es/button";
import Image from "antd/es/image";
import message from "antd/es/message";
import { appType } from "./constants";
import { roundTokens, truncate } from "./utils";
import { useVerifyReserves } from "./useVerifyReserves";
import { toUnits } from "thirdweb";

export interface LiberlandPayProps {
    formModel: FormModel;
}

export const LiberlandPay: React.FunctionComponent<LiberlandPayProps> = (props) => {
    const [api, contextHolder] = message.useMessage();
    const label = `${roundTokens(toUnits(props.formModel.toAmount, 18), 18, 2)} ${props.formModel.token} to ${truncate(props.formModel.recipient)} on ${props.formModel.toChain}`;
    const llUrl = new URL(`${settings.liberlandUrl}/${props.formModel.orderId}`);
    llUrl.searchParams.append("price", props.formModel.fromAmount);
    llUrl.searchParams.append("toId", settings.seller.ll);
    const encodedParams: CallbackParams = {
        step: 2,
        formModel: props.formModel,
    };
    llUrl.searchParams.append("callback", encodeURIComponent(
        `${window.location.protocol}//${window.location.host}?encoded=${window.btoa(JSON.stringify(encodedParams))}`
    ));
    const failedParams: CallbackParams = {
        step: 4,
        formModel: props.formModel,
    }
    llUrl.searchParams.append("failure", encodeURIComponent(
        `${window.location.protocol}//${window.location.host}?encoded=${window.btoa(JSON.stringify(failedParams))}`
    ));
    llUrl.searchParams.append("hook", encodeURIComponent(
        settings.hook[appType],
    ));
    llUrl.searchParams.append("remark", label);
    if (props.formModel.token !== "LLD") {
        llUrl.searchParams.append("assetId", settings.usdt.ll);
    }

    const verify = useVerifyReserves();

    return (
        <>
            {contextHolder}
            <Button
                onClick={async () => {
                    const verified = await verify.mutateAsync(props.formModel);
                    if (verified) {
                        window.location.href = llUrl.toString();
                    } else {
                        api.error("Not enough reserves, try again later");
                    }
                }}
                icon={<Image src={require("../logo-small.png")} width="22px" height="22px" preview={false} />}
                className="LiberlandButton LiberlandButton--payment"
                type="primary"
            >
                Pay
            </Button>
        </>
    );
};
